import { request } from './request'
import type { PostSort, PostStatus, RoadmapPost } from './types'

export type FetchPostsArgs = {
  sort: PostSort
  status: PostStatus | null
  q: string
  limit: number
  offset: number
}

export const fetchPosts = async ({
  sort,
  status,
  q,
  limit,
  offset,
}: FetchPostsArgs): Promise<RoadmapPost[]> => {
  const params = new URLSearchParams({
    sort,
    limit: String(limit),
    offset: String(offset),
  })

  if (status) {
    params.set('status', status)
  }

  if (q.trim()) {
    params.set('q', q.trim())
  }

  const data = await request<{ posts: RoadmapPost[] }>({
    path: `/api/posts?${params.toString()}`,
  })

  return data.posts
}
